import styled, { css } from 'styled-components';

import React from 'react';

const PaginationWrapper = styled.div`
  display: inline-block;
`;

const Page = styled.a`
  color: black;
  float: left;
  padding: ${({ shouldShowNewUi }) => (shouldShowNewUi ? '6px 12px' : '8px 16px')};
  text-decoration: none;
  /* transition: background-color 0.3s; */
  cursor: pointer;
  border: 1px solid #ddd;
  ${({ active, shouldShowNewUi }) => {
    return active
      ? css`
          background-color: ${shouldShowNewUi ? '#2b2b2b' : ' #3498db'};
          color: white;
          border: 1px solid ${shouldShowNewUi ? '#2b2b2b' : ' #1874ff'};
        `
      : ``;
  }}
  &:hover:not(.active) {
    color: ${({ shouldShowNewUi }) => shouldShowNewUi && 'black'};
    background-color: #ddd;
  }
`;

const getWidth = ({ page, perPage, count }) => {
  const w = 2,
    t = 5,
    start = 1,
    end = Math.ceil((count ? count : 1000) / perPage);
  let l = page - start,
    r = end - page;
  if (l < w) return { from: start, to: Math.min(end, page + (t - 1 - l)) };
  else if (r < w) return { from: Math.max(start, page - (t - 1 - r)), to: end };
  else return { from: page - w, to: page + w };
};

export default function Pagination({
  page,
  perPage,
  count,
  onPageChange,
  shouldShowNewUi,
}) {
  const { from, to } = getWidth({ page, perPage, count });
  const pages = [];
  for (let i = from; i <= to; i++) pages.push(i);

  return (
    <PaginationWrapper>
      {from !== 1 && (
        <Page shouldShowNewUi={shouldShowNewUi} onClick={() => onPageChange(from - 1)}>
          &laquo;
        </Page>
      )}
      {pages.map(p => (
        <Page
          shouldShowNewUi={shouldShowNewUi}
          key={p}
          active={p === page}
          onClick={() => onPageChange(p)}
        >
          {p}
        </Page>
      ))}
      {count > perPage * to && (
        <Page shouldShowNewUi={shouldShowNewUi} onClick={() => onPageChange(to + 1)}>
          &raquo;
        </Page>
      )}
    </PaginationWrapper>
  );
}
